import React, { Component } from 'react';
import { Row, Col } from 'react-bootstrap';

export default class Time extends Component {

  constructor() {
    super();
    var now = new Date();
    this.state = { time: now };
  }

  tick() {
    var now = new Date();
    this.setState({time: now});
  }

  componentDidMount() {
    this.timerID = setInterval(() => {
       this.tick()
    }, 1000);
  }

  componentWillUnmount(){
    clearInterval(this.timerID);
  }

  pad(n) {
    return (n < 10) ? ("0" + n) : n;
  }

  getTime() {
    const { time } = this.state;
    let hour = time.getHours();
    let minute = time.getMinutes();
    minute = this.pad(minute);
    let half = '';
    if (hour > 11) {
      half = 'PM';
      if (hour > 12) {
        hour = hour - 12;
      }
    } else {
      half = 'AM';
    }
    return (
      <div>
        <h3>{hour}<span className="p-sm">:</span>{minute}<span className="pl-sm">{half}</span></h3>
      </div>
    );
  }

  render() {
    const { time } = this.state;
    const dayNames = ['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday'];
    return (
      <div className="col-sm-5ths">
        <div className="panel widget">
          <Row className="row-table">
            <Col sm={5} className="bg-purple-dark">
              <h3>{time.getMonth() + 1}
                <span className="pl"> / {this.state.time.getDate()}</span>
              </h3>
            </Col>
            <Col sm={7}>
              <h3>{dayNames[time.getDay()]}</h3>
              {this.getTime()}
            </Col>
          </Row>
        </div>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./master/jsx/components/Common/time.jsx